module.exports = __webpack_public_path__ + "block-2-0.75x-eef565f17411d766bc45c33207faf46d.webp";